import React, { useState } from 'react';
import { Container, Notification, Paper } from '@mantine/core';
import { inject, observer } from 'mobx-react';
import Shell from '../../global/component/organism/Shell/Shell.tsx';
import { IQuestionnaireAnswerPayload } from '../../global/entities/QuestionnaireAnswer/QuestionnaireAnswer.ts';
import { t } from 'i18next';
import { AppMedError } from '../../global/error/AppMedError.ts';
import { usePostQuestionnaireAnswer } from '../../global/entities/QuestionnaireAnswer/mutations/usePostQuestionnaireAnswerMutations.tsx';
import AppmedSurvey from './AppmedSurvey.tsx';

const CollaboratorSurvey: React.FC = inject()(
    observer(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const taskId = urlParams.get('taskID');
        const invitationToken = urlParams.get('invitationToken');

        const [error, setError] = useState<string | null>(null);
        const postQuestionnaireAnswer = usePostQuestionnaireAnswer();

        const handleSubmit = async (formValues: IQuestionnaireAnswerPayload) => {
            setError(null);

            try {
                await postQuestionnaireAnswer.mutateAsync(formValues as unknown as IQuestionnaireAnswerPayload);
                console.log(t('submissionSuccess'));
            } catch (e) {
                if (e instanceof AppMedError) 
                    setError(e.message);
                 else 
                    setError('An unexpected error occurred.');
                
            }
        };

        return (
            <Shell>
                <Container size={'md'} p={0} mt={'lg'}>
                    <Paper>
                        {taskId && invitationToken && (
                            <AppmedSurvey
                                handleSubmit={handleSubmit}
                                taskId={taskId}
                                invitationToken={invitationToken}
                            />
                        )}
                    </Paper>
                    {error && (
                        <Notification mt={'lg'} color={'red'}>
                            {error}
                        </Notification>
                    )}
                </Container>
            </Shell>
        );
    }),
);

export default CollaboratorSurvey;
